import {useContext} from 'react';

import WorkspacesContext from '../../contexts/WorkspacesContext';

const useWorkspaces = () => {
  return useContext(WorkspacesContext);
};

export default useWorkspaces;
